import Typography from '@mui/material/Typography';
import React from 'react';
import { Icon } from 'shared/components/ui/icon';
import { Toggle } from 'shared/components/ui/toggle';
import { v4 as uuidv4 } from 'uuid';

import * as Styled from './meta-toggle.style';

export type MetaToggleProps = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  disabled?: boolean;
  fullWidth?: boolean;
  id?: string;
  children?: React.ReactNode;
};

export const MetaToggle: React.FC<MetaToggleProps> = ({
  label,
  checked,
  onChange,
  icon,
  disabled,
  fullWidth,
  id = uuidv4(),
  children,
}) => {
  const _onChange = () => !disabled && onChange(!checked);

  return (
    <Styled.Label
      htmlFor={id}
      $fullWidth={!!fullWidth}
      $isDisabled={!!disabled}
    >
      {!!icon && (
        <Styled.IconWrapper>
          <Icon icon={icon} />
        </Styled.IconWrapper>
      )}
      <Styled.Content>
        <Typography variant="body2">{label}</Typography>
        {children}

        <Styled.Handle>
          <Toggle
            id={id}
            value="value"
            onChange={_onChange}
            checked={checked}
          />
        </Styled.Handle>
      </Styled.Content>
    </Styled.Label>
  );
};
